import type L from 'leaflet';

// Custom panes used by pane-bound layers in utils/geo-json.ts and utils/circle.js.
// Order defines stacking: each pane gets z-index 410 + its index.
export const DEVICE_MAP_PANES = [
  'cellaccuracy',
  'wifiaccuracy',
  'cellfixes',
  'wififixes',
  'gpsfixes',
  'blefixes',
  'tracksGroup',
  'stops',
  'positions',
] as const;

/**
 * Creates the device map panes. Must run right after `L.map(...)`, before any
 * pane-bound layer is added: a path added to a missing pane makes Leaflet throw
 * in `Renderer.onAdd` (ENG-3025) and leaves the path without a renderer, so the
 * next `clearLayers()` throws in `Path.onRemove` (ENG-3024).
 *
 * Idempotent: an existing pane is kept, so renderers already attached to it
 * are not orphaned.
 */
export function createDeviceMapPanes(map: L.Map) {
  DEVICE_MAP_PANES.forEach((name, index) => {
    if (map.getPane(name)) return;
    map.createPane(name).style.zIndex = String(410 + index);
  });
}
